export default __webpack_public_path__ + "524c9591b175f1f601dc3a3cc51bb927.png";